import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { isEmpty } from "lodash";
import RTL from "../../../helpers/direction/RTL";
import TextField from "@mui/material/TextField";
import { Triangle } from "react-loader-spinner";
import ViewportList from "react-viewport-list";
import { userBalance } from "../../../actions/user";
import { updateUsersDeposits } from "../../../services/userServices";
import { addComma } from "../../../utils/addComma";
import {
  showBetterCoinBalance,
  showBetterUsdtBalance,
} from "../../../utils/showBetterPrice";
///STYLES & ICONS
import styles from "./Wallet.module.scss";
import SearchIconBlue from "../../../styles/icon/SearchIconBlue.svg";
import TimerIcon from "../../../styles/icon/timer.svg";
import ArrowIcon from "../../../styles/icon/arrow_wallet.svg";

//FOR ACCORDION
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import { errorMessage, successMessage } from "../../../utils/messages";
import {
  hiddenLoadingPage,
  showLoadingPage,
} from "../../../actions/loadingPage";
////
import { LoadingPage } from "../../LoadingPage/LoadingPage";

export default function Wallet() {
  const dispatch = useDispatch();
  //GET USER BALANCE'S INFO
  const ref = useRef(null);
  const LoadingBar = useSelector((state) => state.loadingBar.loading);
  let TAKE_DATA = useSelector((state) => state.market.data);
  let userBalanceInfo = useSelector((state) => state.fullUserInfo?.balances);
  //Search and Filter's Options
  const [filterOptions, setFilterOptions] = useState({
    deactivatedButton: false,
    searchItem: "",
    byUserBalance: false,
  });
  useEffect(() => {
    let mounted = true;
    if (mounted) {
      (async () => {
        dispatch(showLoadingPage());
        await dispatch(userBalance());
        dispatch(hiddenLoadingPage());
      })();
    }
    return () => (mounted = false);
  }, []);
  //
  const getStateOfUserCoin = (coins) => {
    if (!isEmpty(userBalanceInfo?.balance)) {
      const keys = Object.keys(userBalanceInfo?.balance);
      let price = 0;
      keys?.map((key) => {
        if (key === coins.toUpperCase()) {
          price = showBetterCoinBalance(userBalanceInfo.balance[key].amount);
          return price;
        }
      });
      return price;
    }
    return 0;
  };
  const getDollarPriceUserCoin = (coin, usdt) => {
    const calculator = getStateOfUserCoin(coin);
    if (calculator) {
      const amount = calculator * usdt;
      return showBetterUsdtBalance(amount);
    }
    return 0;
  };

  const getUpdatePrice = async (item) => {
    try {
      setFilterOptions({ ...filterOptions, deactivatedButton: true });
      const { data } = await updateUsersDeposits(item);
      await dispatch(userBalance());
      successMessage(data.message);
    } catch (ex) {
      errorMessage("مشکلی در بروزرسانی رخ داد");
    } finally {
      const time = setTimeout(() => {
        setFilterOptions({ ...filterOptions, deactivatedButton: false });
      }, 3000);
      return () => clearTimeout(time);
    }
  };

  const LIST_OF_COINS =
    TAKE_DATA && !filterOptions.byUserBalance
      ? TAKE_DATA.filter(
          (coin) =>
            coin.faName.includes(filterOptions.searchItem) ||
            coin.name
              .toLowerCase()
              .includes(filterOptions.searchItem.toLowerCase()) ||
            coin.symbol
              .toLowerCase()
              .includes(filterOptions.searchItem.toLowerCase())
        )
      : TAKE_DATA &&
        filterOptions.byUserBalance &&
        TAKE_DATA.filter((coin) =>
          Object.keys(userBalanceInfo?.balance)?.includes(coin.symbol)
        );
  return (
    <>
      {LoadingBar && <LoadingPage />}
      <div className={styles.container}>
        <div className={styles.header_background}>
          <div className={styles.header_wallet_container}>
            <div className={styles.title_of_balance}>کل موجودی</div>
            <div className={styles.user_money_dollar}>
              <span style={{ paddingLeft: "4px", paddingRight: "2px" }}>$</span>
              <span>{userBalanceInfo?.total?.totalUsdt}</span>
            </div>
            <div className={styles.user_money_rial}>
              <div
                style={{
                  display: "inline-block",
                  fontSize: "12.5px",
                  paddingLeft: "3px",
                  paddingRight: "2px",
                }}
              >
                تومان
              </div>
              <span>{addComma(userBalanceInfo?.total?.totalPrice)}</span>
            </div>
            <div className={styles.title_of_withdraw_24h}>
              میزان برداشت در ۲۴ ساعت
            </div>
            <div className={styles.withdraw_in_24h}>
              <div
                style={{
                  display: "inline-block",
                  fontSize: "11.5px",
                  paddingLeft: "3px",
                  paddingRight: "2px",
                }}
              >
                تومان
              </div>
              <span>{userBalanceInfo?.dailyAmount?.split("-")}</span>
            </div>
            <Link to="/my-profile/transactions?f=wth-dep">
              <div className={styles.button_history_of_withdraw}>
                تاریخچه واریز و برداشت
              </div>
            </Link>
          </div>
        </div>
        <div className={`changeBackgroundColorToBlack ${styles.wallet_body}`}>
          <div className={styles.searchBox_container}>
            <div className={styles.filterBox}>
              <label htmlFor="filterBox-wallet-balance">
                <div className={styles.grid_system}>
                  <input
                    type="checkbox"
                    id="filterBox-wallet-balance"
                    onChange={(e) =>
                      setFilterOptions({
                        ...filterOptions,
                        byUserBalance: e.target.checked,
                      })
                    }
                  />
                  <div className={`font_color_white ${styles.title}`}>
                    نمایش بر اساس موجودی
                  </div>
                  <div className={styles.check}></div>
                </div>
              </label>
            </div>
            <div className={`${styles.search_input_place} wallet-global`}>
              <RTL>
                <TextField
                  className={`darkModeInTradeList ${styles.number_login_input}`}
                  name="phoneNumber"
                  label="جستجو"
                  autoComplete="off"
                  onChange={(e) =>
                    setFilterOptions({
                      ...filterOptions,
                      searchItem: e.target.value,
                    })
                  }
                />
                <div
                  className={`convertPicToGreen ${styles.icon_place} ${styles.first_input_icon} `}
                >
                  <img src={SearchIconBlue} alt="find" />
                </div>
              </RTL>
            </div>
          </div>
          <div className={`font_color_white ${styles.table_wallet_info}`}>
            <div>نام ارز</div>
            <div>موجودی</div>
          </div>
          <section className={styles.table_of_coins_wallet}>
            <ul className={styles.accordion_ul_wallet}>
              {isEmpty(LIST_OF_COINS) && (
                <div className={styles.loadingBar}>
                  <Triangle color="#10D078" height={80} width={80} />
                </div>
              )}
              <div className="scroll-container" ref={ref}>
                <ViewportList
                  viewportRef={ref}
                  items={LIST_OF_COINS}
                  itemMinSize={60}
                  margin={8}
                >
                  {(item) => (
                    <li
                      key={item.name + item.symbol}
                      className="wallet-global "
                    >
                      <Accordion className="changeBackgroundColorToHardBlack">
                        <AccordionSummary>
                          <div className={styles.accordion_container}>
                            <div className={styles.coin_pic}>
                              <img
                                src={`/images/assets-logo/${item.symbol}.png`}
                                alt={item.symbol}
                                width={45}
                                height={45}
                              />
                            </div>
                            <div
                              className={`font_color_white ${styles.coin_eng_name}`}
                            >
                              {item.name}/{item.symbol}
                            </div>
                            <div
                              className={`font_color_white ${styles.coin_fa_name}`}
                            >
                              {item.faName}
                            </div>
                            <div
                              className={`font_color_white ${styles.amount_coin_of_user}`}
                            >
                              <div
                                className={`${styles.arrow_wallet_accordion} ArrowImgWallet convertPicToGreen`}
                              >
                                <img
                                  src={ArrowIcon}
                                  alt=""
                                  width={9}
                                  height={9}
                                />
                              </div>
                              <div className={styles.amount_of_coin}>
                                {getStateOfUserCoin(item.symbol)}
                              </div>
                              <div className={styles.symbol_of_coin}>
                                {item?.symbol}
                              </div>
                            </div>
                          </div>
                        </AccordionSummary>
                        <AccordionDetails>
                          <div
                            className={`changeBackgroundColorToHardBlack ${styles.accordion_container_invisible}`}
                          >
                            <button
                              disabled={filterOptions.deactivatedButton}
                              className={styles.update_price}
                              onClick={() => getUpdatePrice(item?.symbol)}
                            >
                              <div>برروزرسانی</div>
                              <img
                                src={TimerIcon}
                                alt=""
                                width={13}
                                height={13}
                              />
                            </button>
                            <div
                              className={`font_color_white ${styles.price_coin_into_accordion}`}
                            >
                              <div>
                                <span>$</span>
                                <span>
                                  {getDollarPriceUserCoin(
                                    item?.symbol,
                                    item?.usdtPrice
                                  )}
                                </span>
                              </div>
                            </div>
                            <div className={styles.button_of_coin}>
                              <Link to={`/sell/${item.symbol}`}>
                                <button className={styles.sell_coin_btn}>
                                  فروش
                                </button>
                              </Link>
                              <Link to={`/buy/${item.symbol}`}>
                                <button className={styles.buy_coin_btn}>
                                  خرید
                                </button>
                              </Link>
                              <Link to={`/withdraw/${item.symbol}`}>
                                <button className={styles.change_coin_btn}>
                                  برداشت
                                </button>
                              </Link>
                              <Link to={`/deposit/${item.symbol}`}>
                                <button className={styles.order_coin_btn}>
                                  واریز
                                </button>
                              </Link>

                              <Link
                                to={`/withdraw/${item.symbol}?wth=internal`}
                              >
                                <button className={styles.transfer_coin_btn}>
                                  انتقال
                                </button>
                              </Link>
                            </div>
                          </div>
                        </AccordionDetails>
                      </Accordion>
                    </li>
                  )}
                </ViewportList>
              </div>
            </ul>
          </section>
        </div>
      </div>
    </>
  );
}
